import React from 'react';
import { useLanguage } from '../../../hooks/useLanguage';

interface CiteProps {
  filename: string;
  apa: string;
  bibtex: string;
}

const Cite: React.FC<CiteProps> = ({ filename, apa, bibtex }) => {
  const [language] = useLanguage();
  const en = language === 'en';
  const data = { filename, apa, bibtex };

  return (
    <details className="cite">
      <summary className="cite__trigger">
        {en ? 'Cite this paper' : 'Cite deze paper'}
      </summary>
      <div className="cite__menu">
        <button
          type="button"
          className="cite__item"
          data-action="copy"
          data-format="apa"
        >
          {en ? 'Copy APA' : 'APA kopiëren'}
        </button>
        <button
          type="button"
          className="cite__item"
          data-action="copy"
          data-format="bibtex"
        >
          {en ? 'Copy BibTeX' : 'BibTeX kopiëren'}
        </button>
        <button
          type="button"
          className="cite__item"
          data-action="download"
          data-format="apa"
        >
          {en ? 'Download .txt (APA)' : 'Download .txt (APA)'}
        </button>
        <button
          type="button"
          className="cite__item"
          data-action="download"
          data-format="bibtex"
        >
          {en ? 'Download .bib (BibTeX)' : 'Download .bib (BibTeX)'}
        </button>
      </div>
      <script
        type="application/json"
        className="cite__data"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </details>
  );
};

export default Cite;
